<div class="alert alert-danger" role="alert" *ngIf="erro && !editando">{{erro}}</div>

<kendo-dialog *ngIf="editando" [minWidth]="320" [width]="600" (close)="fecheEdicao()">
  <div class="comissionamento-modal" [class.receita-touch]="fila">
    <div class="comissionamento-header">
      <span class="comissionamento-header-icon"><i class="fas fa-utensils"></i></span>
      <h4>{{fila ? 'Escolher receita' : 'Configurar produção'}}</h4>
      <button type="button" class="comissionamento-close" [disabled]="salvando" (click)="fecheEdicao()" aria-label="Fechar">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="comissionamento-body">
      <div class="comissionamento-produto mb-3">
        <span class="comissionamento-produto-icon"><i class="fas fa-cube"></i></span>
        <strong>{{editando.quantidade}} × {{editando.itemPedido.descricao}}</strong>
      </div>
      <div class="alert alert-danger" *ngIf="erro">{{erro}}</div>
      <div class="row">
        <fieldset class="atendimento col-12 mb-3" *ngIf="!fila && editando.pedido.origem !== 'interno'" [disabled]="salvando || editando.pedido.status === 1">
          <legend>Atendimento</legend>
          <div class="atendimento-opcoes">
            <label class="atendimento-opcao" [class.selecionada]="editando.atendimento === 'produzir'">
              <input type="radio" [name]="'atendimento-config-' + editando.id" value="produzir" [(ngModel)]="editando.atendimento"
                     (ngModelChange)="ajusteFichaAoMudarAtendimento()" [ngModelOptions]="{standalone: true}">
              <i class="fas fa-utensils" aria-hidden="true"></i>
              <strong>Produzir agora</strong>
            </label>
            <label class="atendimento-opcao" [class.selecionada]="editando.atendimento === 'vitrine'">
              <input type="radio" [name]="'atendimento-config-' + editando.id" value="vitrine" [(ngModel)]="editando.atendimento"
                     (ngModelChange)="ajusteFichaAoMudarAtendimento()" [ngModelOptions]="{standalone: true}">
              <i class="fas fa-store" aria-hidden="true"></i>
              <strong>Usar pronto/vitrine</strong>
            </label>
          </div>
          <small class="d-block text-muted mt-1" *ngIf="editando.atendimento === 'vitrine'">
            <ng-container *ngIf="!fichasPermitidas().length">Produto já produzido. Sem escolha de ficha, envio ao confeiteiro/KDS ou baixa de estoque.</ng-container>
            <ng-container *ngIf="fichasPermitidas().length">Usa o estoque do produto pronto, sem enviar ao confeiteiro/KDS. A saída do estoque será confirmada ao marcar o pedido como Pronto.</ng-container>
          </small>
          <small class="d-block text-muted mt-1" *ngIf="editando.pedido.status === 1">
            Para mudar o atendimento, volte o pedido para Novo.
          </small>
        </fieldset>
        <fieldset class="receitas col-12 mb-3" *ngIf="fila" [disabled]="salvando">
          <legend>Ficha / receita</legend>
          <div class="receita-opcoes">
            <label class="atendimento-opcao receita-opcao" *ngFor="let f of fichasPermitidas()"
                   [class.selecionada]="editando.fichaId === f.id">
              <input type="radio" [name]="'receita-config-' + editando.id" [value]="f.id"
                     [(ngModel)]="editando.fichaId" [ngModelOptions]="{standalone: true}">
              <strong>{{f.nome}}</strong>
              <i class="fas fa-check-circle" *ngIf="editando.fichaId === f.id" aria-hidden="true"></i>
            </label>
          </div>
        </fieldset>
        <ng-container *ngIf="!fila && moduloComissionamentoAtivo && editando.atendimento === 'produzir'">
          <label class="col-12 mb-3">
            {{labelComissionado}}
            <select class="form-control" [(ngModel)]="editando.comissionadoId" [ngModelOptions]="{standalone: true}" [disabled]="salvando">
              <option *ngIf="!editando.comissionado" [ngValue]="null">Selecione</option>
              <option *ngFor="let u of opcoes.comissionados" [ngValue]="u.id">{{u.nome}}</option>
            </select>
            <small class="text-muted" *ngIf="!opcoes.comissionados.length">
              Cadastre um {{labelComissionado | lowercase}} ativo nesta empresa para atribuir a produção.
            </small>
          </label>
        </ng-container>
      </div>
    </div>
    <div class="comissionamento-footer d-flex">
      <button type="button" class="btn mr-2" [disabled]="salvando" (click)="fecheEdicao()">Cancelar</button>
      <button type="button" class="btn comissionamento-salvar ml-auto" [disabled]="salvando" (click)="salve()">
        <i class="fas fa-save mr-2"></i>Salvar
      </button>
    </div>
  </div>
</kendo-dialog>
